import HttpClient from "../../HttpClient.ts";
import apiRoutes from "../../Routes/Routes.json";

export const PanelNameLookup = (id) => {
  return HttpClient().post(`/${apiRoutes.Compendium.PanelsByReqTypeId}${id}`);
};

export const getReportDisclaimer = (queryModel) => {
  return HttpClient().post(
    `/${apiRoutes.Compendium.ReportDisclaimerGetAll}`,
    queryModel
  );
};

export const ReportDisclaimerSave = (obj) => {
  return HttpClient().post(apiRoutes.Compendium.SaveReportDisclaimer, obj);
};
export const DisclaimerStatus = (id, status) => {
  return HttpClient().post(
    `/${apiRoutes.Compendium.DisclaimerStatusChange}/${id}/${status}`
  );
};

export const ReportDisclaimerDelete = (id) => {
  const path = `${apiRoutes.Compendium.DeleteResultReportDisclaimer}${id}`;
  return HttpClient().post(path);
};
